import React from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import WeekView from "../App/WeekView";
import {
  addMinutes,
  FilterJsonExactlyMatching,
  formateDate,
  GetDifferenceBetweenTwoDatesInMinutes,
  GetIndexExactlyMatchingColumn,
  IsDateTimeBetweenTwoDates,
} from "../Shared/Utility";
import moment from "moment";
import ServiceInfo from "../App/ServiceInfo";
import QuoteInfo from "../App/QuoteInfo";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
function Calander() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const ClientID: any = searchParams.get("cid");
  const [showAnimation, setShowAnimation] = useState(false);
  const [dataArray, setDataArray] = useState([]);
  const [drivers, setdrivers] = useState<any>([]);
  const [Drivers, setDrivers] = useState<any>([]);
  const [helper, setHelper] = useState<any>([]);
  const [driversDB, setdriversDB] = useState<any>([]);
  const [Show24Hours, setShow24Hours] = useState(false);

  const [jobs, setJobs] = useState<any>([]);
  const [selectedjobs, setSelectedjobs] = useState<any>([]);
  const [EventsList, setEventsList] = useState<any>([]);
  const [EventsListDB, setEventsListDB] = useState<any>([]);
  const [MoverUnavailability, setMoverUnavailability] = useState<any>([]);

  const [DateTime, setDateTime] = useState<any>(null);
  const [SelectOption, setSelectOption] = useState<any>(0);
  const [MNVClientID, setMNVClientID] = useState<any>(0);
  const [SelectedJobStatus, setSelectedJobStatus] = useState<any>(0);

  const [m_oToday, setm_oToday] = useState<any>(null);
  const [m_oCurrentPage, setm_oCurrentPage] = useState<any>(null);
  const [m_oSelectedDate, setm_oSelectedDate] = useState<any>(null);

  const [ShowDriver, setShowDriver] = useState(true);
  const [ShowHelpers, setShowHelpers] = useState(true);
  const [BookingMessage, setBookingMessage] = useState<any>({});
  const [BankHolidayText, setBankHolidayText] = useState("");

  // const m_oToday = { year: 2025, month: 9, date: 17 };
  // const m_oCurrentPage = { year: 2025, month: 9, date: 17 };
  // const m_oSelectedDate = { year: 2025, month: 9, date: 17 };

  useEffect(() => {
    var today = new Date();
    let thisDateTime = today;
    setDateTime(thisDateTime);
    if (ClientID && ClientID > 0) {
      setMNVClientID(ClientID);
    }
    let sdate: any = formatDate(today); //("2025-10-17T00:00:00.000Z");
    let thism_oToday = sdate;
    let thism_oCurrentPage = { ...thism_oToday };
    let thiDateTime = new Date(sdate.year, sdate.month, sdate.date, 9, 0, 0, 0);
    setm_oToday(thism_oToday);
    setm_oCurrentPage(thism_oCurrentPage);
    setm_oSelectedDate(thiDateTime);
  }, []);

  useEffect(() => {
    if (DateTime) {
      let thisDateTime = DateTime;

      setm_oToday(formatDate(thisDateTime));
      setm_oSelectedDate(new Date(thisDateTime));
      setm_oCurrentPage(formatDate(thisDateTime));

      getJobs();
    }
  }, [DateTime, MNVClientID]);

  function ChangeDate(value: any) {
    if (value == 1) {
      var d = new Date(DateTime);
      d.setDate(d.getDate() - 1);

      setDateTime(d);
    } else if (value == 2) {
      var d = new Date(DateTime);
      d.setDate(d.getDate() + 1);

      setDateTime(d);
    }
  }

  useEffect(() => {
    getDrivers();
  }, []);

  function getDrivers() {
    axiosAuth
      .get(AppContext.APIURL + "api/MNVMover/MNVMoverGetCompleteDataSet")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          let thisdrivers = FilterJsonExactlyMatching(
            l_oResponse[0],
            "IsDeleted",
            "false",
          );

          thisdrivers = FilterJsonExactlyMatching(
            thisdrivers,
            "IsActive",
            "true",
          );

          let thisDrivers = FilterJsonExactlyMatching(
            thisdrivers,
            "MNVMoverTypeID",
            1,
          );
          thisDrivers = thisDrivers.concat(
            FilterJsonExactlyMatching(thisdrivers, "MNVMoverTypeID", 3),
          );

          let thisHelper = FilterJsonExactlyMatching(
            l_oResponse[0],
            "MNVMoverTypeID",
            2,
          );
          thisHelper = thisHelper.concat(
            FilterJsonExactlyMatching(l_oResponse[0], "MNVMoverTypeID", 3),
          );

          // let thisdriversDB = thisdrivers;
          setDrivers(thisDrivers);
          setHelper(thisHelper);
          setdriversDB(thisdrivers);
          setdrivers(thisdrivers);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getJobs() {
    let object = {} as any;
    object.Date = new Date(DateTime);
    object.JobStatus = SelectOption;
    object.MNVClientID = MNVClientID;

    setJobs([]);
    setSelectedjobs([]);
    setEventsList([]);
    setEventsListDB([]);
    setMoverUnavailability([]);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/MNVQuoteGetCompleteGridDataV3",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setShow24Hours(false);
          setJobs(l_oResponse[0]);
          setSelectedjobs(l_oResponse[0]);
          setEventsList([]);
          setEventsListDB(l_oResponse);
          setMoverUnavailability(l_oResponse[2]);

          setBankHolidayText("");
          if (l_oResponse[3].length > 0)
            setBankHolidayText(l_oResponse[3][0]["Notes"]);

          AssignEventsListData(
            l_oResponse[1],
            l_oResponse[1],
            l_oResponse[2],
            l_oResponse[0],
          );
        }
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error("There was an error!", error);
      });
  }

  function AssignEventsListData(
    p_arrEventsList: any,
    EventsListDB: any,
    thisMoverUnavailability: any,
    Jobs: any,
  ) {
    let thisEventsList = [];
    let thisEventsListDB: any = EventsListDB;
    let thisjobs: any = Jobs;
    let thisShow24Hours = false;
    for (var i = 0; i < p_arrEventsList.length; i++) {
      if (
        p_arrEventsList[i].JobStatus != 1 &&
        (p_arrEventsList[i].JobStatus == SelectedJobStatus ||
          SelectedJobStatus == 0)
      ) {
        var l_oEventRow = p_arrEventsList[i];

        var l_intIndex = GetIndexExactlyMatchingColumn(
          thisjobs,
          "MNVQuoteID",
          l_oEventRow.MNVQuoteID,
        );
        var l_oRow = thisjobs[l_intIndex];
        var l_strDriverAndHelpers = GetDriverAndHelpersText(
          l_oEventRow.MNVQuoteID,
          false,
          true,
          EventsListDB,
        );

        var l_strTextToShow =
          "#" +
          l_oRow.JobID +
          "; " +
          l_oRow.RequestedTimeReplaced +
          "; " +
          l_oRow.MNVMoveTypeServiceName +
          "; " +
          l_strDriverAndHelpers +
          "; " +
          l_oRow.FromPostalCode +
          " to " +
          l_oRow.ToPostalCode +
          "; " +
          l_oRow.RequiredVanTime +
          "hrs";

        var l_strColor = "";
        if (l_oRow.VanTypeFirstLetter == "T") l_strColor = "#157347";
        else l_strColor = "#1573e6";

        thisEventsList.push({
          StartTime: l_oEventRow.StartDateTime,
          EndTime: l_oEventRow.EndDateTime,
          Title: l_strTextToShow,
          Tooltip: l_strTextToShow,
          UserID: l_oEventRow.MNVMoverID,
          Color: l_strColor,
          JobID: l_oRow.JobID,
          JobStatus: l_oRow.JobStatus,
          EventLevel: 2,
        });

        thisEventsListDB[i]["JobID"] = l_oRow.JobID;

        if (!thisShow24Hours) {
          var l_intTotalMinutes = GetDifferenceBetweenTwoDatesInMinutes(
            new Date(l_oEventRow.StartDateTime),
            new Date(l_oEventRow.EndDateTime),
          );
          if (
            new Date(l_oEventRow.StartDateTime).getHours() < 8 ||
            new Date(l_oEventRow.EndDateTime).getHours() >= 20 ||
            new Date(l_oEventRow.EndDateTime).getHours() < 8 ||
            new Date(l_oEventRow.StartDateTime).getHours() >= 20 ||
            l_intTotalMinutes > 720
          )
            thisShow24Hours = true;
        }
      }
    }

    for (var i = 0; i < thisMoverUnavailability.length; i++) {
      //Show24Hours = true;
      var l_strTextToShow = thisMoverUnavailability[i]["Reason"] as string;
      var l_strColor = "#808080";

      if (!thisShow24Hours) {
        if (new Date(thisMoverUnavailability[i].StartDate).getHours() < 8)
          thisMoverUnavailability[i].StartDate = new Date(
            new Date(thisMoverUnavailability[i].StartDate).setHours(8),
          );

        if (new Date(thisMoverUnavailability[i].EndDate).getHours() > 18)
          thisMoverUnavailability[i].EndDate = new Date(
            new Date(thisMoverUnavailability[i].EndDate).setHours(19, 59),
          );
      }
      thisEventsList.push({
        StartTime: thisMoverUnavailability[i].StartDate,
        EndTime: thisMoverUnavailability[i].EndDate,
        Title: l_strTextToShow,
        Tooltip: l_strTextToShow,
        UserID: thisMoverUnavailability[i].MNVMoverID,
        Color: l_strColor,
        JobStatus: -1,
        EventLevel: 1,
      });
    }

    // thisEventsList = new SortJsonData().transform(thisEventsList, 'EventLevel');
    setEventsList(thisEventsList);

    setShow24Hours(thisShow24Hours);
    setShowAnimation(false);
  }

  function GetDriverAndHelpersText(
    p_intMNVQuoteID: any,
    p_boolShowAlert = false,
    p_boolShowOnlyFirstName = false,
    thisEventsListDB: any,
  ) {
    var l_arrFilteredData = FilterJsonExactlyMatching(
      thisEventsListDB,
      "MNVQuoteID",
      p_intMNVQuoteID,
    );
    var l_strText = "";
    for (var i = 0; i < l_arrFilteredData.length; i++) {
      var l_strMoverName = l_arrFilteredData[i]["MNVMoverName"];
      if (p_boolShowOnlyFirstName) {
        var l_arrMoverName = l_strMoverName.split(" ");
        if (l_arrMoverName.length > 0) l_strMoverName = l_arrMoverName[0];
      }
      if (i == 0) l_strText = "D: " + l_strMoverName;
      else if (i == 1) l_strText += "; H1: " + l_strMoverName;
      else if (i >= 2) l_strText += "; H" + i + ": " + l_strMoverName;
    }

    if (p_boolShowAlert) {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "",
        Message: l_strText,
      });
    }

    return l_strText;
  }

  function getToday(): any {
    const l_oTodayDate = new Date();

    return {
      date: l_oTodayDate.getDate(),
      month: l_oTodayDate.getMonth(),
      year: l_oTodayDate.getFullYear(),
    };
  }

  function formatDate(p_oDate: any): any {
    const l_oTodayDate = new Date(p_oDate);

    return {
      date: l_oTodayDate.getDate(),
      month: l_oTodayDate.getMonth(),
      year: l_oTodayDate.getFullYear(),
    };
  }

  // --- Date objects (like Angular) ---
  // const m_oToday = { year: 2025, month: 9, date: 17 };
  // const m_oCurrentPage = { year: 2025, month: 9, date: 17 };
  // const m_oSelectedDate = { year: 2025, month: 9, date: 17 };

  // --- Events ---
  const m_arrEvents: any = [
    // {
    //   id: "9hr1",
    //   StartTime: "26/9/2025, 09:00",
    //   EndTime: "26/9/2025, 11:00",
    //   Text: "Morning Meeting",
    //   URL: "events",
    // },
    // {
    //   id: "14hr2",
    //   StartTime: "26/9/2025, 14:00",
    //   EndTime: "26/9/2025, 15:30",
    //   Text: "Client Call",
    //   URL: "events",
    // },
  ];

  const Events: any = [
    // { id: 1, name: "Morning Meeting" },
    // { id: 2, name: "Client Call" },
  ];

  // --- Resource-related dummy data ---
  const TotalResourcesGridData = [
    { ResourceID: 1, Name: "Projector" },
    { ResourceID: 2, Name: "Car" },
  ];

  const TotalAvailableResourcesGridData = [
    { ResourceID: 1, Available: true },
    { ResourceID: 2, Available: false },
  ];

  const ResourceBookingGridData = [
    { ResourceID: 1, BookingID: 101, UserID: 1 },
    { ResourceID: 2, BookingID: 102, UserID: 2 },
  ];

  const EventRequirementGridData = [
    { RequirementID: 1, Description: "Need snacks for meeting" },
    { RequirementID: 2, Description: "Laptop for call" },
  ];

  const ResourceBookingFiltered = {
    ID: 5001,
    Name: "Special Event Booking",
  };

  // --- AMT + Running Order ---
  const AMTRunningOrder = [
    { OrderID: 1, Step: "Prepare Room" },
    { OrderID: 2, Step: "Start Meeting" },
  ];

  // --- Helpers / Drivers ---
  const drivers2 = [
    { Name: "Driver A", ID: 1 },
    { Name: "Driver B", ID: 2 },
  ];

  const EventsList2 = [
    {
      StartTime: "2025-09-26T09:00:00",
      EndTime: "2025-09-26T11:00:00",
      Title: "Morning Meeting",
      Tooltip: "JobId: 123 - Weekly sync",
      UserID: 1,
      EventLevel: 1,
      Color: "#FFD700",
    },
    {
      StartTime: "2025-09-26T14:00:00",
      EndTime: "2025-09-26T21:00:00",
      Title: "Client Call",
      Tooltip: "JobId: 456 - Project review",
      UserID: 2,
      EventLevel: 2,
      Color: "#90EE90",
    },
  ];

  const ResourcesBookingsList = [
    { ResourceID: 1, BookingID: 101, UserID: 1, Time: "09:00-11:00" },
    { ResourceID: 2, BookingID: 102, UserID: 2, Time: "14:00-15:30" },
  ];

  // --- ToDo + Transfers ---
  const ToDoList = [
    { TaskID: 1, Task: "Prepare slides", Done: false },
    { TaskID: 2, Task: "Check projector", Done: true },
  ];

  const AirportTransfers = [
    { TransferID: 1, Name: "Pickup Guest A", Time: "10:00" },
    { TransferID: 2, Name: "Drop Guest B", Time: "18:00" },
  ];

  // --- Weekend & Holidays ---
  const WeekendDays = [0, 6]; // Sunday + Saturday
  const PublicHolidays = [
    {
      StartDate: "2025-09-25",
      EndDate: "2025-09-25",
      Purpose: "National Holiday",
    },
  ];

  // --- Other props ---
  const IsValueChanged = true;

  // --- Event handler ---
  const handleDayClicked = (event: any) => {
    console.log("Day clicked:", event);
  };

  useEffect(() => {
    if (driversDB && driversDB.length > 0) {
      FilterDriverAndHelpersData();
    }
  }, [ShowDriver, ShowHelpers]);

  useEffect(() => {
    if (EventsListDB && EventsListDB.length > 1) {
      AssignEventsListData(
        EventsListDB[1],
        EventsListDB[1],
        EventsListDB[2],
        EventsListDB[0],
      );
    }
  }, [SelectedJobStatus]);

  function FilterDriverAndHelpersData() {
    let l_arrdriversDB = [...driversDB];
    let thisdrivers = [];
    for (var i = 0; i < l_arrdriversDB.length; i++) {
      if (ShowDriver && l_arrdriversDB[i]["MNVMoverTypeID"] == 1)
        thisdrivers.push(l_arrdriversDB[i]);
      if (ShowHelpers && l_arrdriversDB[i]["MNVMoverTypeID"] == 2)
        thisdrivers.push(l_arrdriversDB[i]);
      if (
        (ShowDriver || ShowHelpers) &&
        l_arrdriversDB[i]["MNVMoverTypeID"] == 3
      )
        thisdrivers.push(l_arrdriversDB[i]);
    }
    setdrivers(thisdrivers);
  }

  useEffect(() => {
    if (jobs && jobs.length > 0) {
      FilterJobsBasedOnJobStatus();
    }
  }, [SelectOption]);

  function FilterJobsBasedOnJobStatus() {
    if (SelectOption == 0) {
      setSelectedjobs(jobs);
    } else {
      let thisselectedjobs = FilterJsonExactlyMatching(
        jobs,
        "JobStatus",
        Number(SelectOption),
      );
      setSelectedjobs(thisselectedjobs);
    }
  }

  function removeExistingDriverAndHelper() {
    var p_arrAssignedData = [] as any;
    p_arrAssignedData.push(SelectedJobId);

    let data = {} as any;
    data.ID = p_arrAssignedData;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVSchedulers/RelMNVQuoteAndMNVMoverDeleteDataSetByMNVQuoteID",
        data,
      )
      .then((response) => {
        let l_oResponse = response.data.Data;
        showSuccessMessage("Assignees have been removed.");
        setShowModal(false);
        getJobs();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function confirmAllJob() {
    let jobToConfirm = [];
    for (var i = 0; i < EventsListDB[1].length; i++) {
      if (EventsListDB[1][i]["JobStatus"] == 2) {
        jobToConfirm.push(EventsListDB[1][i].RelMNVQuoteAndMNVMoverID);
      }
    }
    if (jobToConfirm.length > 0) {
      let object = {} as any;
      object.ID = jobToConfirm;
      axiosAuth
        .post(
          AppContext.APIURL +
            "api/MNVSchedulers/RelMNVQuoteAndMNVMoverConfirmJobSave",
          object,
        )
        .then((response) => {
          showSuccessMessage("All jobs confirmed");
          getJobs();
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      showErrorMessage("No job to confirm");
    }
  }

  const [RequestedTime, setRequestedTime] = useState<any>(null);
  const [MNVMoverTypeID, setMNVMoverTypeID] = useState<any>(1);
  const [MNVVanTypeID, setMNVVanTypeID] = useState<any>(1);
  const [MoversAssignment, setMoversAssignment] = useState<any>([]);
  const [showModal, setShowModal] = useState(false);
  const [SelectedDate, setSelectedDate] = useState<any>(1);
  const [SelectedJobId, setSelectedJobId] = useState<any>(1);
  const [SelectedJobIDDisplay, setSelectedJobIDDisplay] = useState<any>("");
  const [SelectedStatusOfJob, setSelectedStatusOfJob] = useState<any>(1);

  function OpenInfoPopup(
    userInfo: any,
    jobId: any,
    date: any,
    requestTime: any,
    p_intMNVMoverTypeID: any,
    p_intMNVVanTypeID: any,
    p_intStatus: any,
  ) {
    setRequestedTime(requestTime);
    setSelectedDate(date);
    setSelectedJobId(jobId);
    setSelectedStatusOfJob(p_intStatus);

    setMNVMoverTypeID(p_intMNVMoverTypeID);
    setMNVVanTypeID(p_intMNVVanTypeID);
    let thisMoversAssignment: any = [];
    for (var i = 0; i < p_intMNVMoverTypeID; i++) {
      thisMoversAssignment.push({
        MoverID: 0,
        MoverMessage: "",
        VanMessage: "",
      });
    }

    if (p_intStatus != 1) {
      var l_arrFilteredData = FilterJsonExactlyMatching(
        EventsListDB[1],
        "MNVQuoteID",
        jobId,
      );

      for (var i = 0; i < l_arrFilteredData.length; i++) {
        if (thisMoversAssignment[i])
          thisMoversAssignment[i].MoverID = l_arrFilteredData[i]["MNVMoverID"];
      }

      setMoversAssignment(thisMoversAssignment);
    }
    setMoversAssignment(thisMoversAssignment);
    setShowModal(true);
  }

  let SelectedDriver = 0;
  let SelectedHelper = 0;
  let SelectedHelper2 = 0;

  function Clear() {
    SelectedDriver = 0;
    SelectedHelper = 0;
    SelectedHelper2 = 0;
    let thisMoversAssignment = [] as any;
    for (var i = 0; i < MNVMoverTypeID; i++) {
      thisMoversAssignment.push({
        MoverID: 0,
        MoverMessage: "",
        VanMessage: "",
      });
    }
    setMoversAssignment(thisMoversAssignment);
  }

  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [quoteID, setQuoteID] = useState(0);
  function OpenInfoPopUp_Detail(content: any, JobID: any) {
    setQuoteID(JobID);
    setShowQuoteModal(true);
  }

  const AssignJob = (p_intJobStatus: number) => {
    const assignedData: any[] = [];

    // Filter data that match this job ID
    const filteredData = FilterJsonExactlyMatching(
      EventsListDB[1],
      "MNVQuoteID",
      SelectedJobId,
    );

    let okToGo = true;

    // Loop through MoversAssignment (driver + helpers)
    MoversAssignment.forEach((item: any, index: number) => {
      // Find matching record
      const matched = filteredData.find((x: any) => x.RoleID === index + 1);

      const RelMNVQuoteAndMNVMoverID = matched?.RelMNVQuoteAndMNVMoverID || 0;

      assignedData.push({
        RelMNVQuoteAndMNVMoverID,
        UserID: item.MoverID,
        JobID: SelectedJobId,
        JobStatus: p_intJobStatus,
        RoleID: index + 1,
      });

      // Check if any required mover is not selected
      if (item.MoverID <= 0) {
        okToGo = false;
      }
    });

    if (!okToGo) {
      showErrorMessage("Please select driver and helper(s) from dropdown.");
      return;
    }

    // Call API or parent function
    AssignJobToDriverAndHelper(assignedData);
    setShowModal(false);
    Clear();
  };

  const CheckMoverAvailability = (p_intType: number, event: any) => {
    let okToGo = true;
    const moverId = parseInt(event.target.value);
    const filteredJob = FilterJsonExactlyMatching(
      selectedjobs,
      "MNVQuoteID",
      SelectedJobId,
    );

    if (filteredJob.length > 0) {
      let startTime = filteredJob[0].StartTime;

      const unavailableList = FilterJsonExactlyMatching(
        MoverUnavailability,
        "MNVMoverID",
        moverId,
      );

      if (unavailableList.length > 0) {
        for (const item of unavailableList) {
          const StartDateTime = item.StartDate;
          const EndDateTime = item.EndDate;

          if (
            IsDateTimeBetweenTwoDates(StartDateTime, startTime, EndDateTime)
          ) {
            okToGo = false;
            break;
          }
        }
      }
    }

    const sameJob = FilterJsonExactlyMatching(
      selectedjobs,
      "MNVQuoteID",
      SelectedJobId,
    );

    if (sameJob.length > 0) {
      let startTime = sameJob[0].StartTime;
      const currentJobId = sameJob[0].JobID;

      // +1 minute safety adjustment
      startTime = addMinutes(startTime, 1);

      for (const evt of EventsListDB[1]) {
        const StartDateTime = evt.StartDateTime;
        const EndDateTime = evt.EndDateTime;
        const JobID = evt.JobID;

        if (
          JobID !== currentJobId &&
          evt.MNVMoverID === moverId &&
          IsDateTimeBetweenTwoDates(StartDateTime, startTime, EndDateTime)
        ) {
          okToGo = false;
          break;
        }
      }
    }

    BookingMessage.Driver = "";
    BookingMessage.DriverVan = "";
    BookingMessage.Helper1 = "";
    BookingMessage.Helper2 = "";
    let ThisMoversAssignment = [...MoversAssignment];
    ThisMoversAssignment[p_intType - 1].MoverMessage = "";
    ThisMoversAssignment[p_intType - 1].VanMessage = "";

    if (!okToGo) {
      ThisMoversAssignment[p_intType - 1].MoverMessage =
        "There is an overlap. Are you sure you want to schedule this mover for this job?";
    }

    // -------------------------------------------------------------
    // 5. VALIDATE VEHICLE TYPE COMPATIBILITY (DRIVER ONLY)
    // -------------------------------------------------------------
    const driverIndex = GetIndexExactlyMatchingColumn(
      Drivers,
      "MNVMoverID",
      moverId,
    );

    if (
      driverIndex > -1 &&
      Drivers[driverIndex].MNVVanTypeID > 0 &&
      Drivers[driverIndex].MNVVanTypeID !== MNVVanTypeID &&
      p_intType === 1
    ) {
      // Driver warning (Van mismatch)
      if (MNVVanTypeID === 1) {
        ThisMoversAssignment[p_intType - 1].VanMessage =
          "Are you sure you want to assign the Luton driver to Transit?";
      } else {
        ThisMoversAssignment[p_intType - 1].VanMessage =
          "Are you sure you want to assign the Transit driver to Luton?";
      }
    }

    setMoversAssignment([...ThisMoversAssignment]);
  };

  function AssignJobToDriverAndHelper(p_arrAssignedData: any) {
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVSchedulers/RelMNVQuoteAndMNVMoverAssignJobSave",
        p_arrAssignedData,
      )
      .then((response) => {
        getJobs();
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {showAnimation && <LoadingAnimation />}
      <div className="flex-d flex-gap20">
        <div className="shadow-box">
          <div className="flex-d flex-ac flex-gap10 mb-20">
            <div className="field-input w-100">
              <select
                value={SelectOption}
                onChange={(e) => setSelectOption(e.target.value)}
                className="input-field w-100"
              >
                <option value="0">All</option>
                <option value="1">Unassigned</option>
                <option value="2">Assigned</option>
                <option value="3">Confirmed</option>
                <option value="4">Accepted</option>
                <option value="5">Completed</option>
              </select>
            </div>
            <div className="flex-daj btn-start min-w120">
              <a
                className="flex-daj btn-primary min-w120"
                onClick={() => confirmAllJob()}
              >
                Confirm all
              </a>
            </div>
          </div>

          {/* Jobs List */}
          <div className="grid-d flex-gap10 calendar-table flow-auto p-all10 mar-neg cla-flow">
            {selectedjobs.map((job: any) => (
              <div key={job.JobID} className="shadow-box-sm grid-d flex-gap10">
                <div className="flex-da justify-btw flex-as">
                  <div className="grid-d">
                    <span className="job-01">#{job.JobID}</span>
                    <span
                      className="font-12 c-theme"
                      style={{ lineHeight: "12px" }}
                    >
                      {job.ServiceName}
                    </span>
                  </div>
                  <a
                    title={GetDriverAndHelpersText(
                      job.MNVQuoteID,
                      false,
                      false,
                      EventsListDB[1],
                    )}
                    onClick={() =>
                      GetDriverAndHelpersText(
                        job.MNVQuoteID,
                        true,
                        false,
                        EventsListDB[1],
                      )
                    }
                    className="dh-01"
                  >
                    {job.MNVMoverTypeID === 1 && "D"}
                    {job.MNVMoverTypeID === 2 && "D+1"}
                    {job.MNVMoverTypeID >= 3 && `D+${job.MNVMoverTypeID - 1}`}
                  </a>

                  {job.VanTypeFirstLetter === "T" && (
                    <span className="van-01 green-box01">
                      {job.VanTypeFirstLetter}
                    </span>
                  )}
                  {job.VanTypeFirstLetter === "L" && (
                    <span className="van-01 blue-box01">
                      {job.VanTypeFirstLetter}
                    </span>
                  )}

                  {job.JobStatus === 2 && (
                    <a
                      title="Provisional"
                      onClick={() => {
                        OpenInfoPopup(
                          "",
                          job.MNVQuoteID,
                          job.RequestedDate,
                          job.RequiredVanTime,
                          job.MNVMoverTypeID,
                          job.MNVVanTypeID,
                          2,
                        );
                        setSelectedJobIDDisplay(job.JobID);
                      }}
                      style={{ background: "#ff7f27" }}
                      className="booked-01"
                    >
                      P
                    </a>
                  )}

                  {job.JobStatus === 3 && (
                    <a
                      title="Confirmed"
                      onClick={() => {
                        OpenInfoPopup(
                          "",
                          job.MNVQuoteID,
                          job.RequestedDate,
                          job.RequiredVanTime,
                          job.MNVMoverTypeID,
                          job.MNVVanTypeID,
                          3,
                        );
                        setSelectedJobIDDisplay(job.JobID);
                      }}
                      className="booked-01"
                      style={{ background: "#00a2e8" }}
                    >
                      C
                    </a>
                  )}

                  {job.JobStatus === 4 && (
                    <a
                      title="Accepted"
                      onClick={() => {
                        OpenInfoPopup(
                          "",
                          job.MNVQuoteID,
                          job.RequestedDate,
                          job.RequiredVanTime,
                          job.MNVMoverTypeID,
                          job.MNVVanTypeID,
                          4,
                        );
                        setSelectedJobIDDisplay(job.JobID);
                      }}
                      className="booked-01"
                      style={{ background: "#22b14c" }}
                    >
                      A
                    </a>
                  )}

                  {job.JobStatus === 5 && (
                    <a
                      title="Completed"
                      className="booked-01"
                      style={{ background: "#a349a4" }}
                    >
                      C
                    </a>
                  )}

                  {job.JobStatus === 1 && job.MNVQuoteStatusID === 1 && (
                    <a
                      title="Booked"
                      onClick={() => {
                        OpenInfoPopup(
                          "",
                          job.MNVQuoteID,
                          job.RequestedDate,
                          job.RequiredVanTime,
                          job.MNVMoverTypeID,
                          job.MNVVanTypeID,
                          1,
                        );
                        setSelectedJobIDDisplay(job.JobID);
                      }}
                      className="booked-01"
                      style={{ background: "#7f7f7f" }}
                    >
                      B
                    </a>
                  )}

                  {job.JobStatus === 1 && job.MNVQuoteStatusID === 2 && (
                    <a
                      title="Reserved"
                      onClick={() => {
                        OpenInfoPopup(
                          "",
                          job.MNVQuoteID,
                          job.RequestedDate,
                          job.RequiredVanTime,
                          job.MNVMoverTypeID,
                          job.MNVVanTypeID,
                          1,
                        );
                        setSelectedJobIDDisplay(job.JobID);
                      }}
                      className="booked-01"
                      style={{ background: "#FFF77D" }}
                    >
                      R
                    </a>
                  )}

                  {job.LiabilityText !== "" && (
                    <a className="flex-d" title={job.LiabilityText}>
                      <img
                        src="/images/warning.svg"
                        width="24"
                        height="20"
                        alt="warning"
                      />
                    </a>
                  )}

                  {job.FromFloor !== "" && (
                    <a className="flex-d tooltip-wrapper">
                      {" "}
                      <img
                        src="/images/flag.svg"
                        width="18"
                        height="20"
                        alt="Flag"
                      />
                      <div
                        className="tooltip2"
                        dangerouslySetInnerHTML={{
                          __html: job.FromFloor,
                        }}
                      ></div>
                    </a>
                  )}

                  {job.ClientInstructions === "" ? (
                    <a
                      className="flex-d"
                      title="View Details"
                      onClick={() =>
                        OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                      }
                    >
                      <img
                        src="/images/info-norm.svg"
                        width="20"
                        height="20"
                        alt="Info"
                      />
                    </a>
                  ) : (
                    <a
                      title={job.ClientInstructions}
                      onClick={() =>
                        OpenInfoPopUp_Detail("Summary", job.MNVQuoteID)
                      }
                    >
                      <img
                        src="/images/info-red.svg"
                        width="20"
                        height="20"
                        alt="Info"
                      />
                    </a>
                  )}

                  <a
                    title="View Details"
                    href={`/quote_detail/${job.MNVJobID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-d"
                  >
                    <img
                      src="/images/link.svg"
                      width="20"
                      height="20"
                      alt="Info"
                    />
                  </a>
                </div>

                <div className="flex-da justify-btw c-theme font-12">
                  <span>{formateDate(job.StartTime)}</span>
                  <span>arr {job.RequestedTimeReplaced}</span>
                  <span>for {job.RequiredVanTime}hrs</span>
                </div>

                <div className="flex-da justify-btw">
                  <span className="font-12">Postcodes</span>

                  {job.MNVMaterialsPriceTemplateID > 0 && (
                    <a title="Materails Required" className="flex-d">
                      <img
                        src="/images/material-req.svg"
                        width="20"
                        height="20"
                        alt="Flag"
                      />
                    </a>
                  )}
                  {job.CongestionFee > 0 && (
                    <a title="Congestion Charges Applied!" className="c-charge">
                      C
                    </a>
                  )}

                  {job.IsShowLockEmoji === 1 && (
                    <a title="Our Storage" className="flex-d">
                      <img
                        src="/images/lock-g.svg"
                        width="20"
                        height="20"
                        alt="Flag"
                      />
                    </a>
                  )}

                  {job.IsShowDepositOnlySign == 1 && (
                    <a className="flex-d" title="Deposit Only Booking">
                      <img
                        src="/images/pound.svg"
                        width="11"
                        height="16"
                        alt="Flag"
                      />
                    </a>
                  )}
                  <span className="c-theme font-13">
                    {job.FromPostalCode} to {job.ToPostalCode}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="shadow-box shadow-box-lg">
          <div className="flex-da justify-btw mb-10">
            <div className="flex-da flex-gap10">
              <div className="copy-tab copy-tab2">
                <a
                  onClick={() => setShowDriver(!ShowDriver)}
                  className={`name-count ${
                    ShowDriver === true ? "selected" : ""
                  }`}
                >
                  Drivers
                </a>
                <a
                  onClick={() => setShowHelpers(!ShowHelpers)}
                  className={`name-count ${
                    ShowHelpers === true ? "selected" : ""
                  }`}
                >
                  Helpers
                </a>
              </div>
              <div className="field-input">
                <select
                  value={SelectedJobStatus}
                  onChange={(e: any) => setSelectedJobStatus(e.target.value)}
                  className="input-field"
                >
                  <option value="0">All</option>
                  <option value="2">Assigned</option>
                  <option value="3">Confirmed</option>
                  <option value="4">Accepted</option>
                  <option value="5">Completed</option>
                </select>
              </div>
            </div>
            {BankHolidayText != "" && (
              <span className="c-red">Closed: {BankHolidayText}</span>
            )}
            <div className="flex-da flex-gap10">
              <a className="flex-d" onClick={() => ChangeDate(1)}>
                <img
                  src="/images/previous.svg"
                  width="15"
                  height="20"
                  alt="previous"
                />
              </a>
              <input
                className="input-field w-100 field-input"
                placeholder="Date"
                type="date"
                value={moment(DateTime).format("YYYY-MM-DD")}
                onChange={(e) => setDateTime(e.target.value)}
              />
              <a className="flex-d" onClick={() => ChangeDate(2)}>
                <img src="/images/next.svg" width="15" height="20" alt="next" />
              </a>
            </div>
          </div>

          {m_oCurrentPage && (
            <WeekView
              m_oToday={m_oToday}
              m_oCurrentPage={m_oCurrentPage}
              m_oSelectedDate={m_oSelectedDate}
              m_arrEvents={m_arrEvents}
              EventsList={EventsList}
              Helpers={drivers}
              Events={Events}
              TotalResourcesGridData={TotalResourcesGridData}
              TotalAvailableResourcesGridData={TotalAvailableResourcesGridData}
              ResourceBookingGridData={ResourceBookingGridData}
              EventRequirementGridData={EventRequirementGridData}
              EventNameDetails={ResourceBookingFiltered}
              AMTRunningOrder={AMTRunningOrder}
              ResourcesBookingsList={ResourcesBookingsList}
              ToDoList={ToDoList}
              AirportTransfers={AirportTransfers}
              WeekendDays={WeekendDays}
              PublicHolidays={PublicHolidays}
              IsValueChanged={true}
              Show24Hours={Show24Hours}
              BankHolidayText={BankHolidayText}
              dayClicked={handleDayClicked}
            />
          )}
        </div>

        {showModal && (
          <div className="popup-help popup-help-index">
            <div className="help-popup-display">
              <div className="help-inner sm-popup">
                <div className="help-head flex-da justify-btw">
                  <h3 className="bold-font flex-d m-all0">Job Detail</h3>
                  <a className="close-help" onClick={() => setShowModal(false)}>
                    <img
                      src="/images/close.svg"
                      width="15px"
                      height="15px"
                      alt="cross"
                    />
                  </a>
                </div>
                <div className="grid-d flex-gap15 mt-20">
                  <>
                    <div className="flex-d flex-gap10">
                      <span className="txt-compare flex-d">Job ID:</span>
                      <div className="grid-d">
                        <span className="txt-compare flex-d bold-font">
                          #{SelectedJobIDDisplay}
                        </span>
                        {SelectedStatusOfJob !== 1 && (
                          <div className="flex-daj btn-start">
                            <a
                              className="btn-primary flex-daj"
                              style={{ margin: "5px 0 0 0" }}
                              onClick={() => removeExistingDriverAndHelper()}
                            >
                              Remove existing assignees
                            </a>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Driver (index == 0) */}
                    {MoversAssignment.map((Mover: any, index: any) =>
                      index === 0 ? (
                        <div key={index} className="field-input grid-d">
                          <span className="txt-compare flex-d">
                            Select {index === 0 ? "Driver" : `Helper ${index}`}:
                          </span>
                          <>
                            <select
                              value={MoversAssignment[index].MoverID}
                              onChange={(e) => {
                                MoversAssignment[index].MoverID =
                                  e.target.value;
                                CheckMoverAvailability(index + 1, e);
                              }}
                              className="input-field w-100"
                            >
                              <option value="0">
                                Select {index === 0 ? "Driver" : "Helper"}
                              </option>
                              {Drivers.map((driver: any) => (
                                <option
                                  key={driver.MNVMoverID}
                                  value={driver.MNVMoverID}
                                >
                                  {driver.Name}
                                </option>
                              ))}
                            </select>

                            {Mover.MoverMessage &&
                              Mover.MoverMessage !== "" && (
                                <span className="red-span">
                                  {Mover.MoverMessage}
                                </span>
                              )}

                            {Mover.VanMessage && Mover.VanMessage !== "" && (
                              <span className="red-span">
                                {Mover.VanMessage}
                              </span>
                            )}
                          </>
                        </div>
                      ) : null,
                    )}

                    {/* Helpers (index > 0) */}
                    {MoversAssignment.map((Mover: any, index: any) =>
                      index > 0 ? (
                        <div key={index} className="field-input grid-d">
                          <span className="txt-compare flex-d">
                            Select {index === 0 ? "Driver" : `Helper ${index}`}:
                          </span>
                          <>
                            <select
                              value={MoversAssignment[index].MoverID}
                              onChange={(e) => {
                                MoversAssignment[index].MoverID =
                                  e.target.value;
                                CheckMoverAvailability(index + 1, e);
                              }}
                              className="input-field w-100"
                            >
                              <option value="0">
                                Select {index === 0 ? "Driver" : "Helper"}
                              </option>
                              {helper.map((driver: any) => (
                                <option
                                  key={driver.MNVMoverID}
                                  value={driver.MNVMoverID}
                                >
                                  {driver.Name}
                                </option>
                              ))}
                            </select>

                            {Mover.MoverMessage &&
                              Mover.MoverMessage !== "" && (
                                <span className="red-span">
                                  {Mover.MoverMessage}
                                </span>
                              )}

                            {Mover.VanMessage && Mover.VanMessage !== "" && (
                              <span className="red-span">
                                {Mover.VanMessage}
                              </span>
                            )}
                          </>
                        </div>
                      ) : null,
                    )}
                  </>
                </div>
                <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => AssignJob(2)}
                    >
                      Assign
                    </a>
                  </div>
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => AssignJob(3)}
                    >
                      Confirm
                    </a>
                  </div>
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showQuoteModal && (
          <div className="popup-help popup-help-index">
            <div className="help-popup-display">
              <div className="help-inner lg-popup">
                <div className="help-head flex-da justify-btw">
                  <h3 className="bold-font flex-d m-all0">Summary</h3>
                  <a
                    className="close-help"
                    onClick={() => setShowQuoteModal(false)}
                  >
                    <img
                      src="/images/close.svg"
                      width="15px"
                      height="15px"
                      alt="cross"
                    />
                  </a>
                </div>

                <QuoteInfo QuoteID={quoteID} />
                <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowQuoteModal(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Calander;
